import script from "./voca.vue?vue&type=script&setup=true&lang=js"
export * from "./voca.vue?vue&type=script&setup=true&lang=js"

import "./voca.vue?vue&type=style&index=0&id=68693765&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68693765"]])

export default __exports__